import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { AngularAppConfig } from '../../functions';
import { MIME, MimeType } from '../../models';

@Component({
    moduleId: module.id,
    selector: 'angular-file-upload',
    templateUrl: 'file-upload.html',
    styleUrls: ['file-upload.css']
})
export class AngularFileUploadComponent implements OnInit,AfterViewInit {

    @Input() serviceUrl: string;
    @Input() operazione: string;
    @Input() parametri: string;
    @Input() showDropZone: boolean = true;
    @Input() showButton: boolean = true;
    @Input() showFileList: boolean = true;
    @Input() allowUploadsRemove: boolean = true;
    @Input() allowMultiple: boolean = true;
    @Input() allowedExtensions: string[];
    @Input() showSupportedFormats: boolean = true;
    @Input() maxSizeMB: number = null;
    @Input() testoBottone: string = "Scegli file";
    @Output() onError = new EventEmitter();
    @Output() onComplete = new EventEmitter();
    @Output() onInsertComplete = new EventEmitter();

    public uploader: FileUploader;
    public hasBaseDropZoneOver: boolean = false;
    public errorMessage: string = null;
    public allowedMimeTypes: string[];
    public supportedFormats: string;
    

    private fnAddToQueue;
    private fileScartati: string[] = new Array<string>();

    /*
    public files: any;
    public options : any;
    public filters: any;
    */

    constructor() { }

    ngOnInit(): void {
        this.reset();

        if (this.showDropZone) {
            window.addEventListener("dragover", e => {
                e && e.preventDefault();
            }, false);
            window.addEventListener("drop", e => {
                e && e.preventDefault();
            }, false);
        }
    }
    ngAfterViewInit()
    {

    }
    reset() {
        if (this.allowedExtensions && this.allowedExtensions.length > 0) {
            let mimeTypes: MimeType[] = MIME.getByExtensions(this.allowedExtensions);
            this.allowedMimeTypes = mimeTypes.map(m => m.mimeType);
            this.supportedFormats = "." + this.allowedExtensions.join(", .");
        }

        this.uploader = new FileUploader({
            url: AngularAppConfig.RestServiceUrl() + this.serviceUrl,
            allowedMimeType: this.allowedMimeTypes,
            headers: [
                { name: 'operazione', value: this.operazione },
                { name: 'parametri', value: this.parametri }
               //{ name: 'parametri', value: JSON.stringify(this.uploadParams) }               
            ],
            maxFileSize: this.maxSizeMB ? this.maxSizeMB * Math.pow(1024, 2) : null
        });
        this.uploader.onBuildItemForm = this.onBuildItemForm.bind(this);
        this.uploader.onErrorItem = this.onErrorItem.bind(this);
        this.uploader.onAfterAddingAll = this.onAfterAddingAll.bind(this);
        this.uploader.onCompleteAll = this.onCompleteAll.bind(this);
        this.uploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed.bind(this);
        this.fnAddToQueue = this.uploader.addToQueue;
        this.uploader.addToQueue = this.onAddToQueue.bind(this);
    }

    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    remove(item: FileItem) {
        if (item.isUploading) item.cancel();
        item.remove();
    }

    removeAll() {
        if (this.uploader && this.uploader.queue) {
            for (let i = this.uploader.queue.length - 1; i >= 0; i--) {
                this.remove(this.uploader.queue[i]);
            }
        }
    }
    confirmInsertUpload(files)
    {
        /*
        this.fileScartati = new Array<string>();
        this.fnAddToQueue.call(this.uploader, files, this.options, this.filters);
        if(this.fileScartati.length > 0) {
            this.errorMessage = "";
            this.fileScartati.forEach(s => this.errorMessage += s + "<br>");
            this.onError.emit(this.errorMessage);
        }
        */
    }
    onAddToQueue(files, options, filters) {
        /*
        this.files   = files;
        this.options = options;
        this.filters = filters;        
        */
        //this.onInsertComplete.emit(files);
        this.fileScartati = new Array<string>();
        this.fnAddToQueue.call(this.uploader, files, options, filters);
        if(this.fileScartati.length > 0) {
            this.errorMessage = "";
            this.fileScartati.forEach(s => this.errorMessage += s + "<br>");
            this.onError.emit(this.errorMessage);
        }
    }

    onWhenAddingFileFailed(failedFile, filter, options) {
        let scartato: string = "Il file <b>" + failedFile.name + "</b> non è stato caricato.";
        switch (filter.name) {
            case "fileSize":
                scartato = "Il file <b>" + failedFile.name + "</b> supera le dimensioni massime consentite (" + this.maxSizeMB + " MB).";
                break;
            case "mimeType":
                scartato = "Il formato del file <b>" + failedFile.name + "</b> non è supportato.";
                break;
        }
        this.fileScartati.push(scartato);
    }

    onAfterAddingAll(fileItems: any) {
        this.errorMessage = null;
        this.uploader.uploadAll();
    }

    onBuildItemForm(fileItem: FileItem, form: any) {
        fileItem.withCredentials = false;
        this.uploader.authTokenHeader = "token";
        this.uploader.authToken = AngularAppConfig.getUserToken();
    }

    onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
        if (this.errorMessage != null) this.errorMessage += "<br>";
        else this.errorMessage = "";

        this.errorMessage += "<b>" + item.file.name + "</b>: ";

        let r: any;
        try { r = JSON.parse(response); }
        catch (e) { }
        if (r) this.errorMessage += r.ExceptionMessage;
        else this.errorMessage += "Errore nel caricamento file" + ((response && response.trim() != "") ? (" - " + response) : "");

        item.remove();
    }

    onCompleteAll() {
        let fileItems: FileItem[] = this.uploader.queue.filter(x => x.isUploaded);
        if (this.errorMessage) this.onError.emit(this.errorMessage);
        this.onComplete.emit(fileItems);
    }

    getFiles(): Array<string> {
        let files: string[] = new Array<string>();
        if (this.uploader && this.uploader.queue) {
            this.uploader.queue.forEach(x => files.push(x.file.name));
        }
        return files;
    }           
}


// WEBPACK FOOTER //
// ./src/angular_library/components/file-upload/file-upload.component.ts